import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { api, wpImg } from "@/lib/api";

export default function Services() {
  const [services, setServices] = useState([]);
  useEffect(() => { api.get("/services").then((r) => setServices(r.data)).catch(() => {}); }, []);

  return (
    <div data-testid="services-page">
      <section className="relative py-28 md:py-36 px-6 md:px-10 overflow-hidden">
        <div className="absolute inset-0 pattern-girih opacity-25" />
        <div className="relative max-w-5xl mx-auto text-center">
          <div className="text-[11px] uppercase tracking-[0.25em] text-gold font-semibold">What we offer</div>
          <h1 className="display text-5xl md:text-7xl mt-4 text-ink">Services for every stage of life.</h1>
          <p className="mt-6 text-lg text-ink/65 font-light max-w-2xl mx-auto leading-relaxed">
            From education and marriage to medical care and funeral services — FIC supports you through
            every season.
          </p>
        </div>
      </section>

      <section className="pb-24 px-6 md:px-10">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s) => (
            <Link
              key={s.id}
              to={`/services/${s.slug}`}
              data-testid={`service-card-${s.slug}`}
              className="group rounded-3xl overflow-hidden bg-white border border-sand hover:border-navy/30 transition-all hover:-translate-y-1 hover:shadow-xl hover:shadow-navy/5 p-7"
            >
              {s.image_url && (
                <div className="w-16 h-16 rounded-2xl bg-navy/5 flex items-center justify-center mb-5 group-hover:bg-gold/15 transition-colors">
                  <img src={wpImg(s.image_url)} alt="" className="w-10 h-10 object-contain" />
                </div>
              )}
              <h3 className="font-serif text-2xl text-ink group-hover:text-navy transition-colors">{s.title}</h3>
              <p className="mt-2.5 text-sm text-ink/65 leading-relaxed">{s.summary}</p>
              <div className="mt-5 inline-flex items-center gap-2 text-navy text-sm font-medium">
                Learn more <ArrowRight size={14} className="group-hover:translate-x-1 transition-transform" />
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
